// Client-side password strength + requirement helper (display only).
// Never sent anywhere or stored — Supabase Auth is the source of truth.

export const PASSWORD_MIN = 8;

export function passwordChecks(pw = "") {
  return [
    { id: "length", label: `At least ${PASSWORD_MIN} characters`, met: pw.length >= PASSWORD_MIN },
    { id: "upper", label: "An uppercase letter", met: /[A-Z]/.test(pw) },
    { id: "lower", label: "A lowercase letter", met: /[a-z]/.test(pw) },
    { id: "number", label: "A number", met: /\d/.test(pw) },
    { id: "symbol", label: "A symbol (e.g. !@#$)", met: /[^A-Za-z0-9]/.test(pw) },
  ];
}

// Returns { score:0-4, label, tone } for the strength meter.
export function passwordStrength(pw = "") {
  if (!pw) return { score: 0, label: "Enter a password", tone: "muted" };
  const checks = passwordChecks(pw);
  let met = checks.filter((c) => c.met).length;
  if (pw.length >= 12) met += 1; // reward longer passwords
  const score = Math.min(4, Math.max(0, met - 1));
  const map = [
    { label: "Very weak", tone: "error" },
    { label: "Weak", tone: "error" },
    { label: "Fair", tone: "warning" },
    { label: "Strong", tone: "success" },
    { label: "Very strong", tone: "success" },
  ];
  return { score, ...map[score] };
}

// Meets the minimum policy required to submit (all base checks pass).
export function passwordMeetsPolicy(pw = "") {
  return passwordChecks(pw).every((c) => c.met);
}
